import type { PlanChange } from "../../utils";

export function PlanChangeList({
  changes,
}: {
  readonly changes: readonly PlanChange[];
}) {
  return (
    <div className="overflow-hidden rounded-panel border border-border bg-surface">
      {changes.map((change) => (
        <div
          className="grid grid-cols-[2rem_minmax(0,1fr)_auto] items-center gap-3 border-b border-border px-3.5 py-3 text-[13px] last:border-b-0 hover:bg-panel-muted"
          key={change.id}
        >
          <div className="flex h-7 w-7 items-center justify-center rounded-full bg-violet-600 text-[11px] font-semibold text-white">
            {change.initials}
          </div>
          <div className="min-w-0">
            <div className="truncate text-ink">
              <strong>{change.who}</strong> {change.action}
            </div>
            <div className="truncate text-[11px] text-ink-subtle">
              {change.reason}
            </div>
          </div>
          <div className="text-xs text-ink-subtle">{change.date}</div>
        </div>
      ))}
    </div>
  );
}
